"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOverlay = exports.OverlayContextProvider = exports.emitToast = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Toast_1 = require("../components/Toast");
const OverlayContext = react_1.default.createContext(undefined);
let overlayRef = null;
const emitToast = (options) => {
    if (overlayRef) {
        overlayRef.showToast(options);
    }
    else {
        console.warn('OverlayContextProvider is not mounted in the app.');
    }
};
exports.emitToast = emitToast;
const OverlayContextProvider = ({ children }) => {
    const overlayHostRef = react_1.default.useRef(null);
    const [layerHostDomNode, setLayerHostDomNode] = react_1.default.useState(null);
    const [toastsOptions, setToastsOptions] = react_1.default.useState([]);
    const [customToasts, setCustomToasts] = react_1.default.useState({});
    const [floatingIds, setFloatingIds] = react_1.default.useState([]);
    // --- Floating UI ---
    const registerFloating = react_1.default.useCallback((id) => {
        setFloatingIds((prev) => (prev.includes(id) ? prev : [...prev, id]));
    }, []);
    const unregisterFloating = react_1.default.useCallback((id) => {
        setFloatingIds((prev) => prev.filter((item) => item !== id));
    }, []);
    // --- Toasts ---
    const showToast = react_1.default.useCallback((options) => {
        const id = options.id || Date.now().toString();
        setToastsOptions([{ ...options, id }]);
    }, []);
    const hideToast = react_1.default.useCallback((id) => {
        setToastsOptions((prev) => (id ? prev.filter((t) => t.id !== id) : []));
    }, []);
    const registerToast = react_1.default.useCallback((id, toastComponent) => {
        setCustomToasts((prev) => ({ ...prev, [id]: toastComponent }));
    }, []);
    const unregisterToast = react_1.default.useCallback((id) => {
        setCustomToasts((prev) => {
            const next = { ...prev };
            delete next[id];
            return next;
        });
    }, []);
    const hostRefCallback = react_1.default.useCallback((node) => {
        if (node) {
            overlayHostRef.current = node;
        }
        if (react_native_1.Platform.OS === 'web' && node) {
            const globalDom = globalThis;
            if (globalDom.HTMLElement &&
                (node instanceof globalDom.HTMLElement || node._nativeTag instanceof globalDom.HTMLElement)) {
                setLayerHostDomNode(node._nativeTag || node);
            }
            else if (node.nodeType === 1) {
                setLayerHostDomNode(node);
            }
        }
    }, []);
    const contextValue = {
        overlayHostRef,
        layerHostDomNode,
        hasFloatings: floatingIds.length > 0,
        activeFloatingIds: floatingIds,
        registerFloating,
        unregisterFloating,
        showToast,
        hideToast,
        registerToast,
        unregisterToast,
    };
    overlayRef = contextValue;
    return ((0, jsx_runtime_1.jsx)(OverlayContext.Provider, { value: contextValue, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.rootHost, ref: hostRefCallback, pointerEvents: "box-none", children: [children, (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.toastContainer, pointerEvents: "box-none", children: [toastsOptions.map((toast) => ((0, jsx_runtime_1.jsx)(Toast_1.Toast, { title: toast.title, message: toast.message, type: toast.type, duration: toast.duration, onClose: () => hideToast(toast.id) }, toast.id))), Object.entries(customToasts).map(([key, component]) => ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: component }, key)))] })] }) }));
};
exports.OverlayContextProvider = OverlayContextProvider;
const useOverlay = () => {
    const context = react_1.default.useContext(OverlayContext);
    if (!context) {
        throw new Error('useOverlay should be used inside OverlayContextProvider');
    }
    return context;
};
exports.useOverlay = useOverlay;
const styles = react_native_1.StyleSheet.create({
    rootHost: {
        flex: 1,
        width: '100%',
        height: '100%',
    },
    toastContainer: {
        ...react_native_1.StyleSheet.absoluteFill,
        zIndex: 999999,
        elevation: 999999,
        position: react_native_1.Platform.OS === 'web' ? 'fixed' : 'absolute',
    },
});
